import { ImageAndExpandableListV2 } from 'types/studio/studio';
import styles from './SectionButton.module.scss';
import { UnifiedButton, UnifiedButtonType } from '../../UnifiedButton';

type Props = {
  sectionType: string;
  isMainButton?: boolean;
  buttonOptions: ImageAndExpandableListV2['mainButtonOptions' | 'topButtonOptions'];
  theme: ImageAndExpandableListV2['theme'];
};

const SectionButton = ({ sectionType, isMainButton = false, buttonOptions, theme }: Props) => {
  const { addButton, unifiedButton } = buttonOptions || {};

  if (!addButton) {
    return null;
  }

  return (
    <UnifiedButton
      unifiedButton={unifiedButton as UnifiedButtonType}
      sectionType={sectionType}
      className={isMainButton ? styles.mainButton : styles.topButton}
      size={{ xxs: 'medium', xl: 'large' }}
      theme={theme}
    />
  );
};

export default SectionButton;
